import axios from 'axios';

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL || '/api' });

api.interceptors.request.use(config => {
  const token = localStorage.getItem('sqs_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('sqs_token');
      if (window.location.pathname.startsWith('/admin') && window.location.pathname !== '/admin/login')
        window.location.href = '/admin/login';
    }
    return Promise.reject(err);
  }
);

export default api;
